import { render, staticRenderFns } from "./qywh.vue?vue&type=template&id=36bde586&scoped=true&"
import script from "./qywh.vue?vue&type=script&lang=js&"
export * from "./qywh.vue?vue&type=script&lang=js&"
import style0 from "./qywh.vue?vue&type=style&index=0&id=36bde586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bde586",
  null
  
)

export default component.exports